module.exports = __webpack_public_path__ + "static/media/ios-play-circle.51e35ded.svg";